<div class="iackathon-group-list-page__header">
    <h1 class="iackathon-group-list-page__title">
        {{ 'iackathon.group_list' | translate }}
    </h1>
    <a class="iackathon-group-list-page__library-link"
       [routerLink]="['/iackathon-deliverables']">
        <span>{{ 'iackathon.deliverable_library' | translate }}</span>
        <mat-icon svgIcon="folder"></mat-icon>
    </a>
</div>

@if (isLoading()) {
    <mat-spinner></mat-spinner>
} @else {
    <ul class="iackathon-group-list-page__list">
        @for (groupSave of groupSaves(); track groupSave.id) {
            <li class="iackathon-group-list-page__item">
                <app-iackathon-group [save]="groupSave"></app-iackathon-group>
            </li>
        }
    </ul>
}
